// Three search modes the recipient picker supports. Drives the tab UI in
// Stage 1 (SearchColumn) and the mode-aware API param shaping in api.js.
// Order is presentation order — tabs render left → right in this order.
export const SEARCH_MODES = Object.freeze(["semantic", "by_name", "by_outlet"]);

// User-facing tab labels. "Smart match" reads more naturally than
// "Semantic" for non-engineer admins.
export const TAB_LABELS = Object.freeze({
  semantic: "Smart match",
  by_name: "By name",
  by_outlet: "By outlet",
});

// Login-recency dropdown options. Matches ExpertPicker's set — same
// values, same labels — so admins have a consistent experience across
// the two pickers. "any" returns no filter (server interprets nil).
export const LOGIN_RECENCY_OPTIONS = Object.freeze([
  { value: "any", label: "Login recency" },
  { value: "1month", label: "< 1 month" },
  { value: "3months", label: "< 3 months" },
  { value: "6months", label: "< 6 months" },
]);

// Default to "any" to match ExpertPicker's choice: with "1month" the
// picker often returns nothing in dev/seed data and feels broken.
// Tightenable later per team feedback.
export const DEFAULT_LOGIN_RECENCY = "any";
